import React from "react";
import Comment from "./Comment";

const CommentsList = (props) => {
    return (
        <div className="commentContainer">
             {
                props.comments.map((comment, i) => {
                    return <Comment key={i} name={comment.name} comment={comment.comment} likes={comment.likes}/>
                })
            }
        </div>
    )
}

export default CommentsList;